import React, { useMemo } from "react";
import { collapseStatusesPerRecord } from "../../utils/volumeConstants";
import { VolumeStatusBadge } from "./VolumeStatusBadge";
import styles from "./StatusBadgeList.module.css";
export var StatusBadgeList = function (_a) {
    var statusesPerRecord = _a.statusesPerRecord;
    var volumeStatuses = useMemo(function () {
        var collapsed = collapseStatusesPerRecord(statusesPerRecord);
        return collapsed.length === 0 ? ["na"] : collapsed;
    }, [statusesPerRecord]);
    return (React.createElement("span", { className: styles.statusBadgeList }, volumeStatuses.map(function (volumeStatus) { return (React.createElement(VolumeStatusBadge, { key: volumeStatus, status: volumeStatus })); })));
};
